import { format } from 'date-fns'

export const DATE_FORMAT = 'dd/MM/yyyy'

/**
 * Converts a date string or Date object into a formatted string in "dd-MM-yyyy" format.
 * By default, it formats the date using the local timezone. If the `useUTC` flag is
 * set to true, it formats the date using UTC values to avoid timezone-related offsets.
 * @param {string|Date} date
 * @param {boolean} [useUTC=false]
 * @returns {string}
 */
const formatToDate = (date, useUTC = false) => {
  if (!date) return ''

  const d = new Date(date)

  if (useUTC) {
    // Use UTC components
    const yyyy = d.getUTCFullYear()
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0')
    const dd = String(d.getUTCDate()).padStart(2, '0')
    return `${dd}/${mm}/${yyyy}`
  } else {
    // Use local time
    return format(d, DATE_FORMAT)
  }
}

const formatToDateTime = (date) => {
  return date ? format(new Date(date), 'dd/MM/yyyy KK:mmaaa') : ''
}
const formatDateForInput = (date) => {
  return date ? format(new Date(date), 'yyyy-MM-dd') : ''
}

const formatDateAsISO = (date) => {
  return date ? new Date(date).toISOString() : ''
}

const formatOrdinalDate = (date) => format(new Date(date), "do 'of' MMMM yyyy")

const formatShortDate = (date) => format(new Date(date), 'dd/MM/yy')
const formatDateHoursAndSeconds = (date) => (date ? format(new Date(date), 'dd/MM/yyyy HH:mm') : '')

export { formatToDate, formatToDateTime, formatDateAsISO, formatDateForInput, formatOrdinalDate, formatShortDate, formatDateHoursAndSeconds }
